import React from 'react';
import { FormLabel, Grid, useTheme } from '@mui/material';
import { FormTextField } from 'components/common/form';
import { Control, FieldValues, Path } from 'react-hook-form';

type Props<T extends FieldValues> = {
  flexOptions?: {
    label: number;
    value: number;
  };
  control: Control<T, unknown, any>;
  cityName: Path<T>;
  stateName: Path<T>;
};

const LocationFormField = <T extends FieldValues>({ control, flexOptions, cityName, stateName }: Props<T>) => {
  const theme = useTheme();

  return (
    <Grid container flexDirection={{ xs: 'column', sm: 'column', md: 'row' }} sx={{ gap: { xs: 2, sm: 2, md: 0 } }}>
      <Grid flex={flexOptions?.label || 1} sx={{ pt: 1, pr: 1 }}>
        <FormLabel sx={{ color: theme.palette.text.primary, fontWeight: '600' }}>Location</FormLabel>
      </Grid>
      <Grid flex={flexOptions?.value || 4}>
        <FormTextField name={cityName} control={control} fullWidth label="City" />
        <br />
        <br />
        <FormTextField name={stateName} control={control} fullWidth label="State" />
        <br />
        <br />
      </Grid>
    </Grid>
  );
};

export default LocationFormField;
